import {
  Form,
  FormContext,
  Flex,
  Input,
  type IInputProps,
} from 'dash-ui';
import { type ChangeEvent, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { FormFields } from 'containers/properties/PropertyGeneralInformation/components/PropertyGeneralInfoForm/constants/constants';
import useValidation from 'containers/properties/PropertyGeneralInformation/components/PropertyGeneralInfoForm/hooks/useValidation';

const WebsiteInput = (props: IInputProps) => {
  const { t } = useTranslation(['forms', 'common', 'pages']);
  const { formState, formErrors, stateHandlers } = useContext(FormContext);
  const valid = useValidation();

  const onChange =
    (fieldName: FormFields) => (e: ChangeEvent<HTMLInputElement>) => {
      stateHandlers[fieldName](e.target.value);
      valid(fieldName, e.target.value);
    };

  return (
    <Flex flexDirection="column" flex={1}>
      <Form.Label>{t('forms:labels.websiteOfProperty')}</Form.Label>
      <Input
        w="100%"
        value={formState.website || ''}
        placeholder={t('forms:placeholders.websiteOfProperty') || ''}
        onChange={onChange(FormFields.Website)}
        $errorType={formErrors[FormFields.Website]?.type}
        {...props}
      />
      <Form.Feedback $errorType={formErrors[FormFields.Website]?.type}>
        {formErrors[FormFields.Website]?.message}
      </Form.Feedback>
    </Flex>
  );
};

export default WebsiteInput;
